// Blåtur rules and practical info for organizers and participants
// The rules themselves are in blaturRules.js, shared with the e-mails

import React from 'react';
import { RULES, CHANGED_2026 } from './blaturRules';

function BlaturRegler() {
  return (
    <div className="blatur-regler">
      <section className="blatur-section">
        <h2>Reglement</h2>
        <p className="blatur-muted">Signert i Pula, Kroatia, 29. september 2017. Presisert på blåtur 2026.</p>
        <ol className="blatur-rules">
          {RULES.map(rule => (
            <li key={rule.text}>
              {rule.text}{rule.highlight && <> <strong>{rule.highlight}</strong></>}
              {rule.details && <ul>{rule.details.map(d => <li key={d}>{d}</li>)}</ul>}
            </li>
          ))}
        </ol>
        <div className="blatur-note">
          <strong>Endret i 2026:</strong> {CHANGED_2026}
        </div>
      </section>

      <section className="blatur-section">
        <h2>Til arrangørene</h2>
        <ul className="blatur-list">
          <li>Dere bestemmer innhold, tidspunkt og pris. Det er deres tur å styre.</li>
          <li>Sett datoer og send invitasjon så tidlig som mulig, helst rett etter fjorårets tur.</li>
          <li>Samle gjerne tilbakemeldinger underveis. Pris og tidspunkt kan avgjøre om folk får blitt med.</li>
          <li>Hør årsaken før dere registrerer en strike.</li>
          <li>Sørg for at det blir tatt et gruppebilde, og last det opp under Bilder.</li>
          <li>Utnevn neste års arrangører under turen.</li>
        </ul>
      </section>

      <section className="blatur-section">
        <h2>Til deltakerne</h2>
        <ul className="blatur-list">
          <li>Blåtur skal stå øverst på prioriteringslisten. Sett av datoene så snart de er kjent.</li>
          <li>Destinasjonen er ukjent til dere er på vei.</li>
          <li>Kan du ikke delta, si fra til arrangørene med en begrunnelse.</li>
          <li>Turen har tradisjonelt gått i september til november.</li>
        </ul>
      </section>
    </div>
  );
}

export default BlaturRegler;
